import React from "react";
import homeBackgroundFallbackImage from "../../Assets/Images/home-background-fallback.svg";
import "./HomeBackground.less";

const HomeBackgroundFallback = () => {
  return (
    <div id="home-background" className="home-background" aria-hidden="true">
      <div className="home-background__fallback">
        <img
          src={homeBackgroundFallbackImage}
          alt=""
          role="presentation"
          className="home-background__fallback-image"
        />
      </div>
    </div>
  );
};

export default HomeBackgroundFallback;
